import {http} from '@/src/services/config/config-receituario'

export default{
    lista:(token)=>{
        return http.get('estados', {
            headers:{
                'Authorization':token
            }
        })
       
    },
    idEstado:(token, id)=>{
        return http.get('estados/'+id,{
            headers:{
                'Authorization':token
            }
        })
    },
    listaCidades:(token, id)=>{
        return http.get('estados/cidades/'+id,{
            headers:{
                'Authorization':token
            }
        })
    },
    municipio:(token, id)=>{
        return http.get('estados/municipio/'+id, {
            headers:{
                'Authorization':token
            }
        })
    }
}